import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { M8Promocode } from 'services/production/types';

export const createPromocode = async (): Promise<M8Promocode> => {
  const fetchURL = getM8AdminURL('createPromocode');

  const response = await customFetch(fetchURL, { method: 'POST' });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
